import { LayaGL } from "../../layagl/LayaGL";
export class BufferState {
    constructor() {
        this._deviceBufferState = LayaGL.renderDeviceFactory.createBufferState();
    }
    applyState(vertexBuffers, indexBuffer) {
        this._vertexBuffers = vertexBuffers;
        this._bindedIndexBuffer = indexBuffer;
        if (!this._deviceBufferState)
            return;
        if (vertexBuffers.length == 1) {
            BufferState.vertexBufferArray.length = 1;
            BufferState.vertexBufferArray[0] = vertexBuffers[0]._deviceBuffer;
        }
        else {
            BufferState.vertexBufferArray.length = 0;
            vertexBuffers.forEach(element => {
                BufferState.vertexBufferArray.push(element._deviceBuffer);
            });
        }
        this._deviceBufferState.applyState(BufferState.vertexBufferArray, indexBuffer ? indexBuffer._deviceBuffer : null);
    }
    destroy() {
        if (!this._deviceBufferState)
            return;
        this._deviceBufferState.destroy();
        this._deviceBufferState = null;
    }
}
BufferState.vertexBufferArray = [];
